import React, { useCallback } from "react";
import { GlobalBox } from "components/Box/GlobalBox";
import { useDispatch, useSelector } from "react-redux";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { TableInputs } from "components/CardTable/TableInputs";
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { setReportRetentionsFilters, getReportRetentionsAction } from "redux/actions/Reports/reportRetentions/reportRetentionsActions";
import { useSearch } from "hooks/useSearch";

export const ReportRetentionsView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station } = useSelector(state => state.reportRetentions);

  const handleSubmit = useCallback((e, isPdf = true) => {
    e.preventDefault();
    if (!station?.id) { setSnackbar("Falta seleccionar planta.", 'warning'); return; }
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
    dispatch(getReportRetentionsAction({ startDate, endDate, station, isPdf }));
  }, [startDate, endDate, station]);

  return (
    <GlobalBox title="Reporte Retenciones" icon={<AssessmentIcon />}>
      <TableInputs
        reducer="reportRetentions"
        dates
        stations
        maxDate={newDate()}
        dispatchAction={setReportRetentionsFilters}
        submitAction={handleSubmit}
        submitSecond={(e) => handleSubmit(e, false)}
        submitButtonName="PDF"
        loading={isLoadingComp?.loadingRetentions}
      />
      {isLoadingComp?.loadingRetentions && (
        <LoadingComponent height="100%" />
      )}
    </GlobalBox>
  );
};
